import React from "react";
import "./style/CreateJobModal.css";

const ViewJobModal = ({
  open,
  job,
  loading = false,
  onClose,
  typeLabel = (t) => t,
  modeLabel = (m) => m,
}) => {
  if (!open) return null;

  const req = job?.requirements || {};
  const edu = req.education || {};
  const exp = req.experience || {};
  const cert = req.certifications || {};
  const skills = req.skills || {};

  return (
    <div className="modal">
    <form onSubmit={(e) => e.preventDefault()}>
      <div className="modal-header">
        <h2>Job Details</h2>
      </div>

        {loading ? (
          <div>Loading...</div>
        ) : !job ? (
          <div>No job data found.</div>
        ) : (
          <>
            <div className="review-box">
              <div><strong>Title:</strong> {job.title || "—"}</div>
              <div><strong>Department:</strong> {job.department || "—"}</div>
              <div>
                <strong>Location:</strong> {modeLabel(job.locationType)} • {typeLabel(job.type)}
              </div>
              <div><strong>Location (Text):</strong> {job.location || "—"}</div>
              <div><strong>Status:</strong> {job.status || "—"}</div>
              <div><strong>Openings:</strong> {job.openings ?? "—"}</div>
              <div><strong>Validity Days:</strong> {job.validityDays ?? "—"}</div>
              <div><strong>Published At:</strong> {job.publishedAt ? new Date(job.publishedAt).toLocaleString() : "—"}</div>
              <div><strong>Expires:</strong> {job.expiryDate ? new Date(job.expiryDate).toLocaleString() : "—"}</div>
            </div>

            <div style={{ marginTop: 12 }}>
              <h3>Description</h3>
              <div>{job.description || "—"}</div>
            </div>

            {job.keyResponsibilities && (
              <div style={{ marginTop: 12 }}>
                <h3>Key Responsibilities</h3>
                <div>{job.keyResponsibilities}</div>
              </div>
            )}

            <div style={{ marginTop: 12 }}>
              <h3>Requirements</h3>
              <div><strong>Min Education:</strong> {edu.minimum || "—"}</div>
              <div><strong>Preferred Education:</strong> {edu.preferred || "—"}</div>
              <div><strong>Min Experience:</strong> {exp.minimumYears ?? 0} years</div>
              <div><strong>Preferred Experience:</strong> {exp.preferredYears ?? "—"} years</div>

              <div style={{ marginTop: 8 }}>
                <strong>Mandatory Certifications:</strong> {(cert.mandatory || []).join(", ") || "—"}
              </div>
              <div>
                <strong>Preferred Certifications:</strong> {(cert.preferred || []).join(", ") || "—"}
              </div>

              <div style={{ marginTop: 8 }}>
                <strong>Mandatory Skills:</strong> {(skills.mandatory || []).join(", ") || "—"}
              </div>
              <div>
                <strong>Preferred Skills:</strong> {(skills.preferred || []).join(", ") || "—"}
              </div>

              <div style={{ marginTop: 8 }}>
                <strong>Other:</strong> {req.other || "—"}
              </div>
            </div>

            {/* If you ever want: employer/applications exist in API response for employer */}
            {/* job.employer, job.applications are available based on backend include */}
          </>
        )}

       <div className="modal-actions">
        <button type="button" onClick={onClose}>Close</button>
      </div>
    </form>
  </div>
  );
};

export default ViewJobModal;
